module.exports = __webpack_public_path__ + "static/media/screenshot4.7c848040.png";